module.exports = __webpack_public_path__ + "img/about_icon_mining@2x.55a213ed.png";